import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function TurkeyLeaders() {
  const { t } = useTranslation();

  const leaders = [
    {
      name: 'Halide Edib Adıvar',
      years: '1884-1964',
      role: 'Writer, Nationalist, Women\'s Rights Pioneer',
      image: 'https://public.readdy.ai/ai/img_res/15705b4408536e58d6abcbe8828ccfca.jpg',
      achievements: [
        'Key figure in Turkish War of Independence',
        'First female lecturer at Istanbul University',
        'Prolific novelist and political writer',
        'Advocate for women\'s education and rights',
        'Served as corporal in Turkish army during independence war',
        'Authored over 20 novels translated worldwide'
      ],
      quote: 'The liberation of women is not separate from the liberation of the nation.',
      impact: 'Halide Edib Adıvar was a revolutionary figure who fought both on the battlefield and through her pen. During Turkey\'s War of Independence, she served as a corporal, one of the few women in combat roles. As a writer, she challenged traditional gender roles and advocated for women\'s education. Her novels explored themes of nationalism, feminism, and modernization, making her one of Turkey\'s most influential intellectuals.'
    },
    {
      name: 'Sabiha Gökçen',
      years: '1913-2001',
      role: 'World\'s First Female Fighter Pilot',
      image: 'https://readdy.ai/api/search-image?query=confident%20woman%20in%201930s%20aviation%20uniform%20standing%20next%20to%20military%20aircraft%2C%20pilot%20goggles%2C%20Turkish%20flag%20visible%2C%20heroic%20pose%2C%20vintage%20aviation%20photography%2C%20dramatic%20sky%20background&width=800&height=600&seq=tur2&orientation=landscape',
      achievements: [
        'World\'s first female combat pilot (1936)',
        'Flew over 8,000 hours and 22 different aircraft types',
        'Participated in military operations',
        'Adopted daughter of Mustafa Kemal Atatürk',
        'Inspired women worldwide to pursue aviation',
        'Istanbul\'s second airport named in her honor'
      ],
      quote: 'The sky has no limits, and neither should women\'s ambitions.',
      impact: 'Sabiha Gökçen shattered one of the most formidable glass ceilings in history by becoming the world\'s first female fighter pilot. At a time when women were rarely allowed to drive cars, she was flying military aircraft and participating in combat missions. Her courage inspired generations of women to pursue careers in aviation and the military, proving that no field should be off-limits to women.'
    },
    {
      name: 'Türkan Saylan',
      years: '1935-2009',
      role: 'Physician, Educator, Women\'s Rights Activist',
      image: 'https://readdy.ai/api/search-image?query=compassionate%20female%20doctor%20in%20white%20coat%20with%20stethoscope%20helping%20young%20girls%20in%20rural%20Turkish%20village%2C%20warm%20smile%2C%20educational%20setting%2C%20natural%20lighting%2C%20inspiring%20atmosphere&width=800&height=600&seq=tur3&orientation=landscape',
      achievements: [
        'Leading dermatologist specializing in leprosy',
        'Founded Association for Supporting Contemporary Life (ÇYDD)',
        'Provided scholarships to over 50,000 girls',
        'Fought for secular education and women\'s rights',
        'Established schools and dormitories for girls',
        'Received numerous international humanitarian awards'
      ],
      quote: 'Education is the only way to liberate women and society.',
      impact: 'Dr. Türkan Saylan dedicated her life to two missions: eradicating leprosy in Turkey and ensuring every girl had access to education. Through ÇYDD, she provided scholarships, built dormitories, and created opportunities for tens of thousands of girls from poor families to attend school. Her work transformed countless lives and demonstrated that education is the most powerful tool for women\'s empowerment.'
    },
    {
      name: 'Süreyya Ağaoğlu',
      years: '1903-1989',
      role: 'Turkey\'s First Female Lawyer',
      image: 'https://readdy.ai/api/search-image?query=professional%20Turkish%20woman%20in%201930s%20formal%20legal%20attire%20in%20courtroom%20with%20law%20books%2C%20confident%20expression%2C%20historical%20legal%20setting%2C%20professional%20photography%2C%20dramatic%20lighting&width=800&height=600&seq=tur4&orientation=landscape',
      achievements: [
        'First woman to practice law in Turkey (1928)',
        'Defended women\'s rights in landmark cases',
        'Advocate for civil code reforms',
        'Fought for women\'s inheritance and divorce rights',
        'Mentored generations of female lawyers',
        'Author of legal texts on women\'s rights'
      ],
      quote: 'Law must protect the weak, and in our society, women need that protection most.',
      impact: 'Süreyya Ağaoğlu broke into the male-dominated legal profession when women had just gained the right to practice law. She used her position to fight for women\'s legal rights, taking on cases involving inheritance, divorce, and domestic violence. Her courtroom victories established important precedents that expanded women\'s rights under Turkish law and inspired countless women to pursue legal careers.'
    },
    {
      name: 'Safiye Ali',
      years: '1894-1952',
      role: 'Turkey\'s First Female Physician',
      image: 'https://readdy.ai/api/search-image?query=pioneering%20female%20doctor%20in%201920s%20medical%20attire%20examining%20patient%20in%20early%20Turkish%20hospital%2C%20compassionate%20care%2C%20historical%20medical%20setting%2C%20professional%20photography%2C%20warm%20lighting&width=800&height=600&seq=tur5&orientation=landscape',
      achievements: [
        'First Turkish woman to become a physician (1922)',
        'Opened first women\'s clinic in Istanbul',
        'Specialized in women\'s and children\'s health',
        'Advocate for public health education',
        'Trained female medical students',
        'Pioneered maternal and child healthcare in Turkey'
      ],
      quote: 'Women deserve healthcare provided by women who understand their needs.',
      impact: 'Dr. Safiye Ali broke barriers in medicine at a time when female doctors were virtually unheard of. She opened Turkey\'s first women\'s clinic, providing a safe space where women could seek medical care without stigma. Her work in maternal and child health saved countless lives and paved the way for women in medicine. She proved that women could excel in science and healthcare while serving their communities.'
    },
    {
      name: 'Nezihe Muhiddin',
      years: '1889-1958',
      role: 'Feminist Leader & Women\'s Rights Activist',
      image: 'https://readdy.ai/api/search-image?query=determined%20Turkish%20woman%20in%201920s%20elegant%20attire%20speaking%20at%20women%5Cs%20rights%20rally%2C%20passionate%20expression%2C%20crowd%20of%20women%20supporters%2C%20historical%20activism%20scene%2C%20powerful%20atmosphere&width=800&height=600&seq=tur6&orientation=landscape',
      achievements: [
        'Founded Turkey\'s first women\'s political party (1923)',
        'Established Women\'s People\'s Party',
        'Fought for women\'s suffrage',
        'Advocate for women\'s education and employment',
        'Organized women\'s rights conferences',
        'Published feminist journals and articles'
      ],
      quote: 'Women must have a voice in the laws that govern their lives.',
      impact: 'Nezihe Muhiddin was a fearless feminist who founded Turkey\'s first women\'s political organization. Though her Women\'s People\'s Party was eventually shut down, her activism laid the groundwork for women gaining the right to vote in Turkey in 1934 - earlier than many Western nations. She organized women, published feminist literature, and demanded equal rights at a time when such activism was revolutionary.'
    },
    {
      name: 'Fatma Aliye Topuz',
      years: '1862-1936',
      role: 'First Turkish Female Novelist',
      image: 'https://readdy.ai/api/search-image?query=elegant%20Ottoman%20Turkish%20woman%20in%20traditional%20late%201800s%20attire%20writing%20with%20quill%20pen%20surrounded%20by%20books%20and%20manuscripts%2C%20intellectual%20setting%2C%20historical%20photography%20style%2C%20soft%20lighting&width=800&height=600&seq=tur7&orientation=landscape',
      achievements: [
        'First published Turkish female novelist (1892)',
        'Wrote novels challenging women\'s traditional roles',
        'Translated French literature into Turkish',
        'Advocate for women\'s education',
        'Published essays on women\'s rights',
        'Pioneered feminist literature in Ottoman Empire'
      ],
      quote: 'A woman\'s pen can be as mighty as any sword in fighting for justice.',
      impact: 'Fatma Aliye Topuz broke literary barriers in the late Ottoman Empire by becoming the first Turkish woman to publish novels. Her works explored women\'s inner lives, challenged arranged marriages, and advocated for education. Writing at a time when women\'s voices were rarely heard in public, she used literature as a tool for social change and inspired future generations of female writers.'
    },
    {
      name: 'Leyla Gencer',
      years: '1928-2008',
      role: 'World-Renowned Opera Singer',
      image: 'https://readdy.ai/api/search-image?query=elegant%20opera%20singer%20in%20stunning%20performance%20gown%20on%20grand%20opera%20house%20stage%2C%20dramatic%20lighting%2C%20powerful%20singing%20pose%2C%20luxurious%20theater%20setting%2C%20professional%20stage%20photography&width=800&height=600&seq=tur8&orientation=landscape',
      achievements: [
        'Internationally acclaimed soprano',
        'Performed at La Scala, Metropolitan Opera, Covent Garden',
        'Known as "La Diva Turca"',
        'Sang over 70 different opera roles',
        'Cultural ambassador for Turkey',
        'Mentored young Turkish opera singers'
      ],
      quote: 'Music transcends borders, and so should women\'s dreams.',
      impact: 'Leyla Gencer, known as "La Diva Turca," brought Turkish talent to the world\'s most prestigious opera stages. Her powerful voice and dramatic performances earned international acclaim, proving that Turkish women could compete at the highest levels of classical music. She became a cultural ambassador, showing the world Turkey\'s artistic excellence while inspiring young Turkish musicians to pursue their dreams.'
    },
    {
      name: "Sofiya Kudryavtseva",
      role: "Women's Rights Advocate & Policy Expert",
      location: "Turkey 🇹🇷",
      image: "https://readdy.ai/api/search-image?query=Professional%20woman%20advocate%20policy%20expert%20speaking%20at%20conference%20podium%2C%20confident%20leadership%20pose%2C%20modern%20business%20attire%2C%20neutral%20professional%20background%2C%20high-quality%20portrait%20photography&width=400&height=500&seq=301&orientation=portrait",
      bio: "Leading policy reform initiatives for women's economic empowerment and workplace equality across Turkey.",
      achievements: [
        "Authored 15+ policy papers on gender equality",
        "Advisor to Turkish Women's Foundation",
        "Established mentorship programs for 500+ women"
      ],
      quote: "Policy change starts with brave conversations and persistent action."
    },
    {
      name: "Bahar Yetis Irez",
      role: "Digital Rights & Safety Advocate",
      location: "Luxembourg 🇱🇺",
      image: "https://readdy.ai/api/search-image?query=Tech-savvy%20woman%20advocate%20digital%20rights%20expert%20working%20on%20laptop%2C%20modern%20office%20environment%2C%20professional%20appearance%2C%20focused%20expression%2C%20contemporary%20workplace%20setting&width=400&height=500&seq=302&orientation=portrait",
      bio: "Pioneering digital safety education and combating online violence against women in Luxembourg and beyond.",
      achievements: [
        "Founded SafeSpace Digital Platform",
        "Trained 1000+ women in digital literacy",
        "Partnered with tech companies on safety protocols"
      ],
      quote: "Every woman deserves to feel safe in digital spaces as much as physical ones."
    },
    {
      name: "Judit Nagy",
      role: "Economic Justice & Entrepreneurship Coach",
      location: "Turkey 🇹🇷",
      image: "https://readdy.ai/api/search-image?query=Successful%20businesswoman%20entrepreneur%20coach%20in%20modern%20office%2C%20confident%20professional%20portrait%2C%20business%20casual%20attire%2C%20inspiring%20leadership%20presence%2C%20contemporary%20workspace%20background&width=400&height=500&seq=303&orientation=portrait",
      bio: "Empowering women entrepreneurs and advocating for equal economic opportunities in Turkish business landscape.",
      achievements: [
        "Launched 200+ women-owned businesses",
        "Secured €2M+ in funding for female entrepreneurs",
        "Created Turkey's largest women's business network"
      ],
      quote: "Economic independence is the foundation of all other freedoms."
    },
    {
      name: "Silvia Gimenez",
      role: "International Human Rights Lawyer",
      location: "International",
      image: "https://readdy.ai/api/search-image?query=International%20human%20rights%20lawyer%20woman%20in%20professional%20legal%20setting%2C%20authoritative%20presence%2C%20formal%20business%20attire%2C%20law%20office%20background%2C%20confident%20expert%20portrait&width=400&height=500&seq=304&orientation=portrait",
      bio: "Fighting for women's rights on the global stage, with focus on legal frameworks and international advocacy.",
      achievements: [
        "Represented women's cases at UN Human Rights Council",
        "Published extensively on international women's law",
        "Advisor to multiple governments on gender legislation"
      ],
      quote: "Justice knows no borders, and neither should women's rights."
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <div className="relative h-[60vh] flex items-center justify-center">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Istanbul%20skyline%20with%20Bosphorus%20bridge%20and%20mosques%20at%20sunset%2C%20Turkish%20flag%2C%20beautiful%20golden%20hour%20lighting%2C%20inspiring%20atmosphere%2C%20professional%20photography%2C%20vibrant%20colors&width=1920&height=1080&seq=turhero&orientation=landscape"
            alt="Turkey"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
        </div>
        <div className="relative z-10 text-center text-white px-6 max-w-4xl">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">
            Pioneering Women of Turkey
          </h1>
          <p className="text-xl md:text-2xl mb-8 leading-relaxed">
            Celebrating the extraordinary women who shaped Turkey's history, culture, and progress
          </p>
        </div>
      </div>

      {/* Introduction */}
      <div className="max-w-4xl mx-auto px-6 py-16">
        <div className="prose prose-lg max-w-none">
          <p className="text-lg leading-relaxed text-gray-700 mb-6">
            Turkey has a rich history of remarkable women who broke barriers, challenged traditions, and paved the way for future generations. From the world's first female fighter pilot to pioneering doctors, lawyers, and writers, Turkish women have consistently demonstrated courage, intelligence, and determination.
          </p>
          <p className="text-lg leading-relaxed text-gray-700">
            These women fought on battlefields, in courtrooms, in hospitals, and through their art. They demanded education, equal rights, and opportunities at times when society said women should stay silent. Their legacies continue to inspire women in Turkey and around the world to pursue their dreams fearlessly.
          </p>
        </div>
      </div>

      {/* Leaders Grid */}
      <div className="max-w-7xl mx-auto px-6 pb-20">
        <div className="space-y-20">
          {leaders.map((leader, index) => (
            <div
              key={index}
              className={`flex flex-col ${
                index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
              } gap-12 items-start`}
            >
              {/* Image */}
              <div className="lg:w-1/2">
                <div className="relative rounded-2xl overflow-hidden shadow-2xl h-[400px]">
                  <img
                    src={leader.image}
                    alt={leader.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>

              {/* Content */}
              <div className="lg:w-1/2 space-y-6">
                <div>
                  <h2 className="text-4xl font-bold text-gray-900 mb-2">
                    {leader.name}
                  </h2>
                  <p className="text-lg text-teal-600 font-medium mb-1">
                    {leader.role}
                  </p>
                  <p className="text-gray-600">{leader.years}</p>
                </div>

                {/* Quote */}
                <div className="bg-teal-50 border-l-4 border-teal-500 p-6 rounded-r-lg">
                  <p className="text-lg italic text-gray-700">
                    "{leader.quote}"
                  </p>
                </div>

                {/* Achievements */}
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-4">
                    Key Achievements
                  </h3>
                  <ul className="space-y-2">
                    {leader.achievements.map((achievement, i) => (
                      <li key={i} className="flex items-start gap-3">
                        <i className="ri-checkbox-circle-fill text-teal-500 text-xl flex-shrink-0 mt-0.5"></i>
                        <span className="text-gray-700">{achievement}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Impact */}
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    Her Impact
                  </h3>
                  <p className="text-gray-700 leading-relaxed">
                    {leader.impact}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Call to Action */}
      <div className="bg-gradient-to-r from-teal-500 to-teal-600 py-20">
        <div className="max-w-4xl mx-auto px-6 text-center text-white">
          <h2 className="text-4xl font-bold mb-6">
            Their Legacy Lives in You
          </h2>
          <p className="text-xl mb-8 leading-relaxed">
            These women proved that courage, education, and determination can change history. What will you create?
          </p>
          <div className="flex flex-wrap gap-4 justify-center">
            <Link
              to="/blog"
              className="px-8 py-4 bg-white text-teal-600 rounded-full font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap"
            >
              Read More Stories
            </Link>
            <Link
              to="/community"
              className="px-8 py-4 bg-teal-700 text-white rounded-full font-semibold hover:bg-teal-800 transition-colors whitespace-nowrap"
            >
              Join Our Community
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
